import script from "./FooterApp.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterApp.vue?vue&type=script&setup=true&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=673dc012&lang=scss"

const __exports__ = script;

export default __exports__